function escapeCsvField(value) {
  const str = value === null || value === undefined ? '' : String(value)
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * Builds CSV/JSON files client-side and triggers a browser download.
 */
export function useFileExport() {
  function downloadCsv(headers, rows, filename) {
    const lines = [headers, ...rows].map((row) => row.map(escapeCsvField).join(','))
    const csvContent = lines.join('\r\n')
    // UTF-8 BOM so Excel opens non-ASCII characters correctly.
    const BOM = '﻿'
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
    triggerDownload(blob, filename)
  }

  function downloadJson(data, filename) {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json;charset=utf-8;' })
    triggerDownload(blob, filename)
  }

  return { downloadCsv, downloadJson }
}
